import {createRouter, createWebHashHistory} from 'vue-router'
import $store from '@/store'
import DefaultLayout from '@/layouts/DefaultLayout'
import iStoreLocalData from '@/scripts/istore-local-data';

const routes = [
  {
    path: '/',
    name: 'Root',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: {
      title: 'OneConsole | Welcome',
    },
  },
  {
    path: '/pluginInit',
    name: 'pluginInit',
    component: () => import('@/views/PluginInit.vue'),
    meta: {
      title: 'OneConsole | PluginInit',
    },
  },
  {
    path: '/home',
    name: 'Home',
    component: DefaultLayout,
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        // Route level code-splitting
        // This generates a separate chunk (about.[hash].js) for this route
        // Which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard.vue'),
        meta: {
          title: 'OneConsole | Dashboard',
          requireAuth: true,
        },
      },
      {
        path: '/getAccount',
        name: 'GetAccount',
        component: () =>
          import('@/views/GetAccount.vue'),
        meta: {
          title: 'OneConsole | License',
          requireAuth: true,
        },
      },
      {
        path: '/changePassword',
        name: 'ChangePassword',
        component: () =>
          import('@/views/ChangePassword.vue'),
        meta: {
          title: 'OneConsole | Change Password',
          requireAuth: true,
        },
      },
      {
        // This is a route for "Plugin Manager" plugin
        path: '/pluginManager',
        name: 'PluginManager',
        component: () =>
          import('@/views/PluginManager.vue'),
        meta: {
          title: 'OneConsole | Plugin Manager',
          requireAuth: true,
        },
      },
      {
        path: '/watermarkSetting',
        name: 'WatermarkSetting',
        component: () =>
          import('@/views/WatermarkSetting.vue'),
        meta: {
          title: 'OneConsole | Watermark Setting',
          requireAuth: true,
        },
      },
      {
        path: '/sidebarTest',
        name: 'sidebarTest',
        component: () =>
          import('@/components/IStoreSidebarNav.vue'),
        meta: {
          title: 'OneConsole | SIDEBAR TEST',
          requireAuth: true,
        }
      },
    ],
  },
  {
    // This is a route for "Plugin Manager" plugin
    path: '/apiManager',
    name: 'ApiManager',
    component: () =>import('@/views/ApiManager.vue'),
  },
  {
    path:'/openConcioAdmin',
    name:'OpenConcioAdmin',
    component:()=>import('@/views/OpenConcioAdmin.vue'),
  }

]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
    // Always scroll to top
    return {top: 0}
  },
})

router.beforeEach((to, from, next) => {
  let isAuthenticated = iStoreLocalData.isAuthenticated()

  if (!$store.state.loginUser.userFunctions) {
    isAuthenticated = false
  }

  if (to.meta.requireAuth) {
    if (isAuthenticated) {
      if (from.path === '/dashboard' && $store.state.isValidUrl === false) {
        // If we navigate from non-existent URL, we need to set isValidUrl in Vuex store to true
        $store.commit('setChosenUrlValidity', true)
      }
      if (to.meta.title) {
        document.title = to.meta.title
      }
      next()
    } else {
      next({path: '/'})
    }
  } else {
    // If there is no path defined other than login page and the ones inside 'requireAuth'
    if (to.path === '/login' || to.path === '/' || to.path === '/pluginInit' || to.path === '/openConcioAdmin' || to.path === '/apiManager') {
      // Allow display of login page
      if (to.meta.title) {
        document.title = to.meta.title
      }
      if ((from.path === '/dashboard' || from.path === '/notfound') && to.path === '/login') {
        // When users accidentally clicked browser "Back" button from dashboard, there's a chance they'll get into login page
        // We need to dispatch logout to prevent users from being locked out because of new login API
        if ($store.state.logoutClicked === false) {
          // Prevent another logout dispatch if logout is performed through normal process (a click on Logout button)
          $store.dispatch('logOut')
        }
      }
      next()
    } else {
      // No other specified paths
      $store.commit('setChosenUrlValidity', false)
      // Force navigate to /dashboard so the URL is not modified
      next({path: '/dashboard', replace: true})
    }
  }
})

export default router
